import { Base_Url } from "../../BaseURL/BaseUrl";
import { getListWithAuthenticated, postApiWithAuthenticated } from "../ApiMethods/ApiMethod";

const base = `${Base_Url}/RoleType`;
export const AddUpdateRoleType = async (apiParam) => {
    const url = `${base}/AddUpdateRoleType`;
    const res = await postApiWithAuthenticated(url, apiParam);
    return res;
};
export const GetRoleTypeModel = async (RoleTypeID) => {
    const url = `${base}/GetRoleTypeModel?RoleTypeID=${RoleTypeID}`;
    const res = await getListWithAuthenticated(url);
    return res;
};